import { Auction } from '@/api';
import PBBidDetails from '@/components/ecommerce/product/ProductBid/Components/PBBidDetails';
import Price from '@/components/general/Price';
import If, { Else, ElseIf } from '@/components/util/IF';
import AuctionPricePromotion from '@/contexts/AuctionPricePromotion';
import useAuth from '@/contexts/AuthContext';
import useAuction from '@/hooks/useAuction';
import useItemContext from '@/hooks/useItemContext';
import useOffers from '@/hooks/useOffers';
import clsx from 'clsx';
import i18next from 'i18next';
import React from 'react';

const ProductEcomAuctionPromotion = () => {
    const { item } = useItemContext();
    const { user } = useAuth();
    const { hasAuction, auction, auctionOver, endTime } = useAuction(item, undefined, true);
    const { offerPossible } = useOffers(item, true);
    const hasAuctionFlag = hasAuction && !offerPossible;

    return (
        <If condition={hasAuctionFlag}>
            <PBBidDetails hasAuction={hasAuction} auctionOver={auctionOver} endTime={endTime} auction={auction} />
            <If condition={auction?.type === Auction.TypeEnum.BuyNow}>
                <If condition={auctionOver}>
                    <div>
                        <AuctionPricePromotion auction={auction}>{({ isPromoted, amount, promotedAmount }) => {
                            return (
                                <div>{i18next.t('common:item-text.sold-out')}
                                    <Price className={clsx('@[600px]:text-[2rem] text-[1rem] font-[700]', { 'line-through @[600px]:text-[1rem] text-red text-sm': isPromoted })} justification="L" number={amount} />
                                    <If condition={isPromoted}>
                                        <Price className={clsx('@[600px]:text-[2rem] text-[1.4rem] font-[700]')} justification="L" number={promotedAmount ?? ''} />
                                    </If>
                                </div>
                            );
                        }}
                        </AuctionPricePromotion>
                    </div>
                    <Else>
                        <div>
                            <AuctionPricePromotion auction={auction}>{({ isPromoted, amount, promotedAmount }) => {
                                return (
                                    <div>{i18next.t('common:item-text.price')}
                                        <Price className={clsx('@[600px]:!text-[2rem] text-[1rem] font-[700]', { 'line-through @[600px]:text-[1rem] text-red text-sm': isPromoted })} justification="L" number={amount} />
                                        <If condition={isPromoted}>
                                            <Price className={clsx('@[600px]:text-[2rem] text-[1.4rem] font-[700]')} justification="L" number={promotedAmount ?? ''} />
                                        </If>
                                    </div>
                                );
                            }}
                            </AuctionPricePromotion>
                        </div>
                    </Else>
                </If>
            </If>
            <ElseIf condition={item?.current_offer_transaction}>
                <If condition={item?.owner_id !== user?.id}>
                    <div>
                        <div>{i18next.t('common:item-text.bought-for')}<Price className="@[600px]:text-[2rem] text-[1rem] font-[700]" justification="L" number={item?.current_offer_transaction?.current_amount ?? '0'} /></div>
                    </div>
                    <Else>
                        <div className="flex justify-between">
                            <div>{i18next.t('common:item-text.sold-for')}<Price className="@[600px]:text-[2rem] text-[1rem] font-[700]" justification="L" number={item?.current_offer_transaction?.current_amount ?? '0'} /></div>
                            <div>{i18next.t('common:offers.payout')}<Price className="@[600px]:text-[2rem] text-[1rem] font-[700]" justification="L" number={item?.current_offer_transaction?.payout_amount ?? '0'} /></div>
                        </div>
                    </Else>
                </If>
            </ElseIf>
        </If>
    );
};

export default ProductEcomAuctionPromotion;
